import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { columnConfigs } from "../columnsConfig"

type Props = {
  checkedIn: number;
}

const CheckInStatusCell = ({ checkedIn }: Props) => {
  const isCheckedIn = checkedIn > 0

  return (
    <Flex align="center" direction="column" alignItems="flex-start">
      <Flex align="center">
        <Icon
          icon={columnConfigs.checkInStatus.icon}
          size={4}
          mr={2}
          color={isCheckedIn ? "green.500" : "gray.400"}
        />
        <Text fontSize="sm" color={isCheckedIn ? "green.500" : "gray.500"} noOfLines={1}>
          {isCheckedIn ? "Checked In" : "Not Checked In"}
        </Text>
      </Flex>
    </Flex>
  )
}

export default CheckInStatusCell
